import { render, staticRenderFns } from "./JdhLogicalRichRadioGroup.vue?vue&type=template&id=0431ea95&scoped=true&"
import script from "./JdhLogicalRichRadioGroup.vue?vue&type=script&lang=ts&"
export * from "./JdhLogicalRichRadioGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0431ea95",
  null
  
)

export default component.exports